import {Moment} from 'moment';

export function weekday(date: Moment): number {
    return date.isoWeekday() === 0 ? 6 : date.isoWeekday() - 1;
}
